import { FC, ReactNode } from "react";
import gendalfIcon from "./icons/gendalf.png";
import { IPopupProps, Popup } from "../Popup";
import { AppContext } from "../../Menu/MenuButton";
import { ThinButton } from "../../Buttons/ThinButton/ThinButton";
import { useNavigate } from "react-router-dom";
import { ActionsContext } from "../../../pages/ActionsPage/ACtionsRoutes";

interface INotEnoughMoneyProps extends IPopupProps {
    textNode: ReactNode;
}

export const NotEnoughMoney: FC<INotEnoughMoneyProps> = ({ textNode, onClose }) => {
    const navigate = useNavigate();

    const toTaskHandler = () => {
        onClose && onClose();
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`);
    }

    const getDescription = () => {   
        return (
            <>
                { textNode }
                <ThinButton caption='Перейти к заданиям' handler={ toTaskHandler } />
            </>
        );
    }

    return (
        <Popup
            title="Ты не пройдешь!"
            description={ <p>{ getDescription() }</p> }
            icon={ gendalfIcon }
            onClose={ onClose }
        />
    );
};
